module.exports = __webpack_public_path__ + "static/purpose-driven-design-process-and-tools-31c8c9e0f0fd83d63612704b91627d54.jpg";